<template>
  <transition name="fade">
    <div
      v-if="message"
      class="absolute top-0 bottom-0 right-0 left-0 z-10 flex flex-col justify-center items-center bg-gray-100/75">
      <div class="flex w-20 h-20 justify-center items-center">
        <i class="material-icons text-5xl animate-ping">online_prediction</i>
      </div>
      <p class="text-gray-500">{{ message }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    message: null
  }
}
</script>

<style>
.fade-enter-from,
.fade-leave-to {
  display: hidden;
}
</style>
